import { gql } from '@apollo/client';

export const cancelEmployeeVisitMutation = gql`
  mutation CancelEmployeeVisitMutation($employeeVisitId: ID!) {
    cancelEmployeeVisit(employeeVisitId: $employeeVisitId)
  }
`;
